import types from './actionTypes';

const initialState = {
  loading: false,
  landingTemplates: [],
  saved: false,
  error: '',
};

const landingTemplate = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_LANDING_TEMPLATE_STATE:
      return initialState;
    case types.SAVE_LANDING_TEMPLATE.REQUEST:
    case types.ARCHIVE_LANDING_TEMPLATE.REQUEST:
      return {
        ...state,
        loading: true,
        saved: false,
        error: '',
      };
    case types.SYNC_LANDING_TEMPLATES.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        landingTemplates: action.templates,
      };
    case types.SAVE_LANDING_TEMPLATE.SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        error: '',
      };
    case types.ARCHIVE_LANDING_TEMPLATE.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case types.SYNC_LANDING_TEMPLATES.FAILURE:
    case types.SAVE_LANDING_TEMPLATE.FAILURE:
    case types.ARCHIVE_LANDING_TEMPLATE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default landingTemplate;
